import { render, staticRenderFns } from "./trainingDetails.vue?vue&type=template&id=b005dcc8&scoped=true&"
import script from "./trainingDetails.vue?vue&type=script&lang=js&"
export * from "./trainingDetails.vue?vue&type=script&lang=js&"
import style0 from "./trainingDetails.vue?vue&type=style&index=0&id=b005dcc8&prod&lang=scss&scoped=true&"
import style1 from "./trainingDetails.vue?vue&type=style&index=1&id=b005dcc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b005dcc8",
  null
  
)

export default component.exports